/* eslint-disable react/no-array-index-key */
import React from 'react';
import styles from './styles.scss';
import cn from 'classnames';

export const ColorDescription = ({ settings, colors, className }) => {
  const defaultColors = [
    {
      text: settings.get('dateTimeSelectionAvailabilityText') || 'Available',
      color: '#DBF2E0',
    },
    {
      text: settings.get('dateTimeSelectionWaitlistText') || 'Join Waitlist',
      color: '#FFE4B3',
    },
    {
      text: settings.get('dateTimeSelectionUnAvailabilityText') || 'Sold Out',
      color: '#F3C4C4',
    },
  ];

  const renderColors = colors || defaultColors;

  return (
    <div className={cn(styles.colorDescription, className)}>
      {renderColors.map((color, index) => (
        <div key={`${color.color}-${index}`} className={styles.colorItem}>
          <div className={styles.colorIndicator} style={{ backgroundColor: color.color }} />
          <div className={styles.description}>{color.text}</div>
        </div>
      ))}
    </div>
  );
};
